import { Card } from "./Card";
import { ensureElement } from "../../../utils/utils";
import { categoryMap } from "../../../utils/constants";
export class CardCatalog extends Card {
    constructor(container, actions) {
        super(container, actions);
        this._image = ensureElement('.card__image', this.container);
        this._category = ensureElement('.card__category', this.container);
    }
    set image(value) {
        this.setImage(this._image, value, this.title);
    }
    set category(value) {
        this.setText(this._category, value);
        for (const key in categoryMap) {
            this._category.classList.toggle(categoryMap[key], key === value);
        }
    }
}
